import React from 'react'
import moment from 'moment';
import 'moment-duration-format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp, faVolumeXmark } from '@fortawesome/free-solid-svg-icons'
import Play from "./Play";
import Pause from "./Pause";
import styles from './Media.module.css'


const Controls = (props: any) => {

    const formatDuration = (duration: number) => {
        return moment.duration(duration, "seconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"});
    }

    return (
        <div className={`${styles.controls}`}>
            <div className="d-flex align-items-center">
                <div>
                    <span className={`${styles.barTime} ${styles.currentTime}`}>{formatDuration(props.curTime)}</span>
                    <span className="px-1">/</span>
                    <span className={styles.barTime}>{formatDuration(props.duration)}</span>
                </div>
                    <FontAwesomeIcon icon={props.isMuted ? faVolumeXmark : faVolumeUp} className={styles.volueIcon} onClick={props.handleMute} />
            </div>
            {
                props.playing ? 
                    <Pause handleClick={() => props.setPlaying(false)} /> :
                    <Play handleClick={() => props.setPlaying(true)} />
            }
        </div>
    )
}

export default Controls
